import React, {useEffect, useState} from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import '../../App.css';

function Bookings() {

    const myParam = window.location.search;
    const history = useNavigate();
    var productId= new URLSearchParams(myParam).get("id");
    const [loading, setLoading] = useState(false);
    const [bookings, setBookings] = useState({});
    const [totalBookings, setTotalBookings] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pagination, setPagination] = useState(0);

    var page = new URLSearchParams(myParam).get("page");
    if (page == null||undefined){
        page = 1
    }

    console.log(productId)
    useEffect(() => {
        const loadPost = async () => {
  
            // Till the data is fetch using API 
            // the Loading page will show.
            setLoading(true);

            try{
              var user = JSON.parse(localStorage.user).user;
              console.log(user)
            } catch(e){
                user = false 
            }
  
            // Await make wait until that 
            // promise settles and return its result

            if (!user){
              notification.open({
                  message: 'Please Log In',
                  description:
                    '',
                  onClick: () => {
                    console.log('Notification Clicked!');
                  },
                });
              history("/login"); 
            } else{

              const response = await axios.get(
              "https://api.bubble.africa/users/bookings/all/"+user.id+"?page="+page).then((res)=>{
                  setBookings(res.data.houses);
                  setTotalBookings(res.data.total)
                  setPagination(res.data.records_per_page)
                  setCurrentPage(Number(page))
                  console.log(res)
              }).catch(()=>{
                  console.log("try")
              });
              //  try{
              //     posts.rooms = JSON.parse(JSON.parse(posts.rooms))
              //  } catch {
              //     posts.rooms = []
              //  }
              // After fetching data stored it in posts state.
              
    
              // Closed the loading page
              
            }
            setLoading(false);
        }
  
        // Call the function
        loadPost();
    },[]);

  return (
    <>
  {loading ? (
                <>
                <img alt='Loader' width ='100%' src='./images/loader.png' />
                </>) :
            (
              <>
                <div className='container mb-5'>
                    <br/>
                    <p class='green-text subheader'>My Dashboard</p>
                    
                    <br/>
                      <p class='green-text subheader-3'>Your Bookings</p>
                    <br/>
                    
                    {bookings.length > 0 ? ([
                      (
                        bookings.map((booking, index) => (
                          <>
                            
                              <div key={booking.id} class='dashboard-tab' style={{height:120}}>
                                <div>
                                  <a href={'/home?id='+booking.id} key={booking.id}>
                                    <p class='subheader-3'>{booking.name.substring(0, 50)}</p>
                                  </a>
                                  <span>
                                  <p class=''>
                                    Location: {booking.location}</p>
                                    <p class=''>Booking Date: {booking.bookingDate}</p>
                                    
                                    </span>
                                </div>
                                <span class='subheader-3'>{'>'}</span>
                                
                              </div>
                            
                          </>
                        ))
                      ),  (
                        <>
                            <div className='row my-5 mx-auto' style={{justifyContent: "space-between",  width:'300px'}}>
                                {(totalBookings/currentPage) > pagination ? (
                                    <>
                                        <a className={"w-10 sign-up nav-links "+(Number(page) < 2 ? "d-none" :"")} href={"?page="+(Number(page)-1)}>Prev Page</a>
                                        <a className="w-10 sign-up nav-links" href={"?page="+(Number(page)+1)}>Next Page</a>
                                    </>
                                ) : (<a className={"w-10 sign-up nav-links "+(Number(page) > 1 ? "" :"d-none")} href={"?page="+(Number(page)-1)}>Prev Page</a>)}
                            </div>
                        </>
                        )]
                    ) : (
                      <>
                        <center>
                          <img class='no-booking' src='./images/empty.png'/>
                            
                          <br/><br/>
                            <p>You don't have any bookings yet</p>
                          <br/><br/><br/>
                          <span>
                            <a href="#API">Find a home now {'>'}</a>
                          </span>
                        </center>
                        </>
                    )}
                    
                </div>
              </>
          )
        }
  </>
  )
}

export default Bookings